enum InferenceProviderDriver {
  OpenResponses = "OpenResponses",
  AnthropicMessages = "AnthropicMessages",
}
export default InferenceProviderDriver;
